import * as React from 'react';

import { SelectionContextState } from './types';

const fallbackCallback = () => console.error('No SelectionContext exists');

// `any` is to avoid needing the table data type in `Table`. You should type the `Column`s using `useTypedColumns`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SelectionContext = React.createContext<SelectionContextState>({
  selection: [],
  isAllSelected: false,
  selectRow: fallbackCallback,
  deselectRow: fallbackCallback,
  selectAll: fallbackCallback,
  deselectAll: fallbackCallback,
});

export default SelectionContext;
